fragment InboxAssignmentFragment on Assignment {
    id
    assignmentEntity {
        ... on Thread {
            id
        }
    }
    assigneeEntity {
        id
        name
    }
}
